import { fromJS } from 'immutable';

export const CLEAR_EDIT_REFERENCE_EVENT = 'CLEAR_EDIT_REFERENCE_EVENT';

export const GET_EDIT_REFERENCE_REQUEST = 'GET_EDIT_REFERENCE_REQUEST';
export const GET_EDIT_REFERENCE_SUCCESS = 'GET_EDIT_REFERENCE_SUCCESS';
export const GET_EDIT_REFERENCE_FAILURE = 'GET_EDIT_REFERENCE_FAILURE';

export const UPDATE_EDIT_REFERENCE_REQUEST = 'UPDATE_EDIT_REFERENCE_REQUEST';
export const UPDATE_EDIT_REFERENCE_SUCCESS = 'UPDATE_EDIT_REFERENCE_SUCCESS';
export const UPDATE_EDIT_REFERENCE_FAILURE = 'UPDATE_EDIT_REFERENCE_FAILURE';

export const CREATE_EDIT_REFERENCE_REQUEST = 'CREATE_EDIT_REFERENCE_REQUEST';
export const CREATE_EDIT_REFERENCE_SUCCESS = 'CREATE_EDIT_REFERENCE_SUCCESS';
export const CREATE_EDIT_REFERENCE_FAILURE = 'CREATE_EDIT_REFERENCE_FAILURE';

export const GET_EDIT_REFERENCE_HAVE_REQUEST = 'GET_EDIT_REFERENCE_HAVE_REQUEST';
export const GET_EDIT_REFERENCE_HAVE_SUCCESS = 'GET_EDIT_REFERENCE_HAVE_SUCCESS';
export const GET_EDIT_REFERENCE_HAVE_FAILURE = 'GET_EDIT_REFERENCE_HAVE_FAILURE';

export const EDIT_REFERENCE_OPEN_CONFIRMATION = 'EDIT_REFERENCE_OPEN_CONFIRMATION';
export const EDIT_REFERENCE_CANCEL_CONFIRMATION = 'EDIT_REFERENCE_CANCEL_CONFIRMATION';

const initialState = fromJS({
  fetched: false,
  reference: {},
  updating: false,

  fetchedHaves: false,
  haves: [],

  formData: {},
  editConfirmationOpen: false,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const editReferenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EDIT_REFERENCE_EVENT:
      return initialState;

    case EDIT_REFERENCE_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        editConfirmationOpen: true,
      }));
    case EDIT_REFERENCE_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        editConfirmationOpen: false,
      }));

    case GET_EDIT_REFERENCE_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));
    case CREATE_EDIT_REFERENCE_REQUEST:
    case UPDATE_EDIT_REFERENCE_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: true,
      }));
    case CREATE_EDIT_REFERENCE_SUCCESS:
    case UPDATE_EDIT_REFERENCE_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        reference: action.response,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_REFERENCE_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        reference: action.response,
        updating: false,
      }));
    case CREATE_EDIT_REFERENCE_FAILURE:
    case UPDATE_EDIT_REFERENCE_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_REFERENCE_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));

    case GET_EDIT_REFERENCE_HAVE_REQUEST:
      return state.merge(fromJS({
        fetchedHaves: false,
      }));
    case GET_EDIT_REFERENCE_HAVE_SUCCESS:
      return state.merge(fromJS({
        fetchedHaves: true,
        haves: action.response.items,
      }));
    case GET_EDIT_REFERENCE_HAVE_FAILURE:
      return state.merge(fromJS({
        fetchedHaves: true,
      }));

    default:
      return state;
  }
};
